import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/pagination';
import styles from './Services.module.scss';
import { serviceData } from '../lib/data';
import ServiceCard from './ServiceCard';



const Services = () => {
    return ( 
        <section>         
            
            <div className={styles.container}>                 
            <Swiper
                    modules={[Pagination]}
                    loop={true}                 
                    pagination={{ clickable: true }}
                    slidesPerView = {1}
                    spaceBetween={20}
                    className={styles.slider}>

                    {serviceData.map((element) => 
                        <SwiperSlide className={styles.slide}  key={element.id}>
                            <ServiceCard                          
                            element={element}/>
                        </SwiperSlide>
                    )}             
                        
            </Swiper>  
            </div>    

     
        </section>
    );
}

export default Services;